module.exports = "/images/green-folder.svg?e4aef70a82c07f13d53c5a1a6f47ca9a";